export default "__VITE_ASSET__kOhhqDtk__"